var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-section",class:{
		'form-section--inline': _vm.isInline,
		'form-section--block--tight': _vm.spacing === _vm.Spacing.TIGHT && !_vm.isInline,
		'form-section--block--regular': _vm.spacing === _vm.Spacing.REGULAR && !_vm.isInline,
		'form-section--block--wide': _vm.spacing === _vm.Spacing.WIDE && !_vm.isInline,
		'form-section--block--loose': _vm.spacing === _vm.Spacing.LOOSE && !_vm.isInline,
		'form-section--block--extra-loose': _vm.spacing === _vm.Spacing.EXTRA_LOOSE && !_vm.isInline,
		'form-section--inline--tight': _vm.spacing === _vm.Spacing.TIGHT && _vm.isInline,
		'form-section--inline--regular': _vm.spacing === _vm.Spacing.REGULAR && _vm.isInline,
		'form-section--inline--wide': _vm.spacing === _vm.Spacing.WIDE && _vm.isInline,
		'form-section--inline--loose': _vm.spacing === _vm.Spacing.LOOSE && _vm.isInline,
		'form-section--inline--extra-loose': _vm.spacing === _vm.Spacing.EXTRA_LOOSE && _vm.isInline,
	}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }